import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDeleteImage } from "../../../hooks/useDeleteImage";

interface ImageDeleteModalProps {
  show: boolean;
  onHide: () => void;
  idActividad: number;
  nombreArchivo: string;
  onSuccess?: () => void;
}

const ImageDeleteModal = ({
  show,
  onHide,
  idActividad,
  nombreArchivo,
  onSuccess,
}: ImageDeleteModalProps) => {
  const [loading, setLoading] = useState(false);
  const { deleteImage } = useDeleteImage();

  const handleDelete = async () => {
    setLoading(true);
    const result = await deleteImage(idActividad, nombreArchivo);
    setLoading(false);

    if (result.success) {
      toast.success(result.message);
      onSuccess?.();
      onHide();
    } else {
      toast.error(result.message);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar imagen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        ¿Estás seguro de que deseas eliminar la imagen <strong>{nombreArchivo}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Eliminando...
            </>
          ) : (
            "Eliminar"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageDeleteModal;
